/**
 * Nombres amigables de las apps del launcher — SOLO frontend.
 *
 * El backend guarda en `app_credentials.name` el slug técnico (p. ej.
 * `ev-ingreso`, `agio-compress`). Para un usuario no técnico ese nombre es
 * críptico, así que aquí lo mapeamos por `slug` a una etiqueta legible. El
 * backend NO cambia: este override vive 100% en el cliente web.
 *
 * Se aplica en un único punto (el cliente `hub.apps` en `auth.js`), de modo que
 * TODOS los consumidores de nombres de app quedan consistentes: las tarjetas del
 * catálogo del launcher, el command palette y los pins del sidebar del shell.
 *
 * Slugs no listados conservan el `name` del backend (fallback). Mantener
 * sincronizado con las apps sembradas por las migraciones (ver
 * `api/migrations/versions/{b8c4d1e0fa92, d1e7a9b3c042, e8f3b1c5d2a1}_*.py`).
 */
export const APP_DISPLAY_NAMES = {
  'firewall-monitor': 'Monitor de Firewall',
  'ev-ingreso': 'Ingreso de Línea Blanca',
  'ev-reparacion': 'Ingreso de Reparación',
  'ev-empaque': 'Empaque de Reparación',
  'dashboard': 'Tableros',
  'agio-compress': 'Compresor de PDF',
  'rpt-embarques': 'Reporte de Embarques',
  'admin-users': 'Usuarios',
  'admin-orm': 'Administración de Datos',
  'admin-audit': 'Auditoría',
  'help': 'Ayuda',
  // Slot `agio-web dev` repurposeado como Visor de Logs (su `name` de DB sigue
  // siendo "agio-web dev" porque es el token de apps/web; aquí lo mostramos lindo).
  'agio-web-dev': 'Visor de Logs',
  'sur-dashboard': 'SUR Dashboard',
  'consumibles': 'Control de Consumibles',
  'control-inventario': 'Control de Inventario',
  'gspn-bom': 'BOMs de GSPN',
  'gspn-repair': 'Tablero DAP',
  'herramientas': 'Herramientas',
  'auditoria-vps': 'Auditoría del Servidor',
  'tableros-odoo': 'Tableros Odoo',
  'planeador': 'Planeador de Materiales',
  'planeador-prod': 'Planeador (convergencia)',
}

/**
 * Devuelve el nombre amigable para un slug, o `fallback` (el `name` del backend)
 * si no hay override. `slug` ausente/desconocido → fallback intacto.
 *
 * @param {string} slug
 * @param {string} [fallback]
 * @returns {string}
 */
export function friendlyAppName(slug, fallback) {
  return APP_DISPLAY_NAMES[slug] || fallback || slug || ''
}
